import {Image, Col} from 'react-bootstrap';

function ContentImage( {src, alt} ) {
  return (
    <Col xs={6} md={4}>
      <Image src={src} alt={alt} thumbnail />
    </Col>
  );
}

export default ContentImage;